import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { catchError, Observable } from 'rxjs';
import { AuthService } from "./auth.service";

@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {

    private deslogando = false;

    constructor(private authService: AuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // A autenticação agora é feita via cookie (HttpOnly) enviado automaticamente
        // pelo navegador, portanto nenhum header de Authorization é adicionado aqui.
        // O withCredentials é necessário para que o navegador envie e armazene o
        // cookie em requisições cross-origin (frontend e backend em origens diferentes).
        const clonedRequest = req.clone({ withCredentials: true });

        return next.handle(clonedRequest).pipe(catchError(error => this.handleError(error)));
    }

    private handleError(err: HttpErrorResponse): Observable<any> {
        return new Observable<any>(observer => {
            if (err.status === 401 && !this.deslogando) {
                // Evita chamadas recursivas quando o próprio POST de logout retornar 401
                this.deslogando = true;
                this.authService.logOut().add(() => {
                    this.deslogando = false;
                });
            }
            // handle your auth error or rethrow
            observer.error(err);
        })
    }
}
